import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getBranchCompanyList, getCardMakeInfo, getProjectDeliveryCardMakeList, bindProjectDeliveryCardMake, addProjectDeliveryCardMake } from '@/api/manageCenter';
import { getCardMakeInfo as getMaterialCardMakeInfo, getCardMakeList as getMaterialCardMakeList, bindCardMake as bindMaterialCardMake, createCardMake as createMaterialCardMake } from '@/views/manageCenter/api/index.js';
import { getconfigCardType } from '@/api/order';
export default {
  props: {
    // 接口模式：project-项目交付（默认），material-物料印刷（物料申请汇总制卡）
    mode: {
      type: String,
      default: 'project'
    }
  },
  data: function data() {
    var _this = this;
    return {
      addCardDialogVisible: false,
      addCardDialogType: 'add',
      addCardDisabledFlag: false,
      // 物料模式下字段置灰（业务类型、物料类型、所属分公司不可编辑）
      materialDisabled: false,
      // 查看模式：由基本信息点击批次号进入，标题为「查看制卡数据」，表单全部置灰只读
      isViewMode: false,
      addCardBtnLoading: false,
      addCardTypeList: [],
      addCardBranchCompanyList: [],
      // 添加&关联制卡类型：1-添加制卡，2-关联已有制卡
      cardMakeType: 1,
      addCardAddForm: {
        channel_id: '',
        channel_name: '',
        card_bin_group_id: '',
        type_id: '',
        warehouse: '',
        make_count: '',
        purpose: '',
        purpose_des: '',
        customer_id: '',
        customer_name: '',
        material_type: '',
        material_type_des: '',
        id: '',
        project_id: '',
        note: '',
        branch_office_data: [{
          branch_office_id: '',
          make_count: ''
        }]
      },
      addCardFormRules: {
        branch_office_data: [{
          validator: function validator(rule, value, callback) {
            if ([0, 2].includes(_this.addCardAddForm.purpose)) {
              if (!value || value.length === 0) {
                return callback(new Error('请添加至少一条卡分配明细'));
              }
            }
            callback();
          },
          trigger: 'change'
        }]
      },
      addCardPurposeList: [{
        name: '公司公版卡',
        id: 0
      }, {
        name: '个性化卡',
        id: 1
      }, {
        name: '测试卡',
        id: 2
      }],
      addCardMaterialTypeList: [{
        name: 'PVC卡',
        id: 1
      }, {
        name: '券',
        id: 2
      }],
      print_id: '',
      item_id: '',
      // 物料印刷模式下的汇总记录ID
      summary_id: '',
      cardMakeList: [],
      cardMakeListLoading: false,
      cardMakeSelection: [],
      cardMakePage: {},
      cardMakeSearchPage: {
        page: 1,
        pagesize: 20
      }
    };
  },
  watch: {
    cardMakeType: function cardMakeType(val) {
      if (val === 2) {
        this.cardMakeSearchPage.page = 1;
        this.cardMakeSelection = [];
        if (this.$refs.cardMakeTable) {
          this.$refs.cardMakeTable.clearSelection();
        }
        this.addCardGetCardMakeList();
      }
    }
  },
  computed: {
    cardTypeChannelList: function cardTypeChannelList() {
      return this.$store.state.user.cardTypeChannelList;
    },
    companyList: function companyList() {
      return this.$store.state.user.companyList;
    },
    addCardTotalCount: function addCardTotalCount() {
      if (!this.addCardAddForm.branch_office_data || this.addCardAddForm.branch_office_data.length === 0) {
        return 0;
      }
      var total = this.addCardAddForm.branch_office_data.reduce(function (sum, item) {
        return sum + (parseInt(item.make_count) || 0);
      }, 0);
      this.addCardAddForm.make_count = total;
      return total;
    }
  },
  created: function created() {
    this.addCardGetBranchCompany();
  },
  methods: {
    open: function open(row, type) {
      this.addCardResetForm();
      // type === 'view' 表示由批次号点击进入的查看模式
      this.isViewMode = type === 'view';
      if (this.isViewMode) {
        this.addCardDisabledFlag = true;
      }
      this.addCardDialogVisible = true;
      if (this.mode === 'material') {
        // 物料印刷模式：row.id 为汇总记录ID
        this.summary_id = row.id;
        // 物料模式下业务类型、物料类型、所属分公司置灰
        this.materialDisabled = true;
      } else {
        this.print_id = row.print_id;
        this.item_id = row.item_id || '';
        this.materialDisabled = false;
      }
      this.getCardMakeInfoData();
    },
    getCardMakeInfoData: function getCardMakeInfoData() {
      var _this2 = this;
      var isMaterial = this.mode === 'material';
      // 物料印刷模式按汇总ID获取制卡信息，项目交付模式按印刷单ID获取
      var params = isMaterial ? {
        summary_id: this.summary_id
      } : {
        print_id: this.print_id,
        item_id: this.item_id
      };
      var request = isMaterial ? getMaterialCardMakeInfo(params) : getCardMakeInfo(params);
      request.then(function (res) {
        if (res.data) {
          var data = res.data;
          _this2.addCardAddForm = _objectSpread({}, data);
          _this2.addCardAddForm.id = data.id;
          if (data.id != 0) {
            _this2.addCardDisabledFlag = true;
          }
          // 物料印刷模式：未绑定时接口不返回用途，默认个性化卡
          if (isMaterial && (_this2.addCardAddForm.purpose === '' || _this2.addCardAddForm.purpose === null || _this2.addCardAddForm.purpose === undefined)) {
            _this2.addCardAddForm.purpose = 1;
          }
          _this2.addCardChangeCardBinId2(_this2.addCardAddForm.card_bin_group_id);
          _this2.addCardRemoteMethod(data.customer_name);
        }
      });
    },
    addCardChangeCardBinId: function addCardChangeCardBinId(val) {
      this.addCardAddForm.type_id = '';
      this.addCardTypeList = [];
      this.addCardGetCardType(val);
    },
    // 业务类型变化时重置卡类型（首次加载）
    addCardChangeCardBinId2: function addCardChangeCardBinId2(val) {
      this.addCardTypeList = [];
      this.addCardGetCardType(val);
    },
    addCardGetCardType: function addCardGetCardType(val) {
      var _this3 = this;
      getconfigCardType({
        business_id: val,
        version: 2,
        create_order: 1
      }).then(function (res) {
        _this3.addCardTypeList = res.data;
        // 只有1个卡类型时自动回填
        if (res.data && res.data.length === 1) {
          _this3.addCardAddForm.type_id = res.data[0].id;
        }
      });
    },
    addCardResetForm: function addCardResetForm() {
      this.cardMakeType = 1;
      this.addCardAddForm = {
        channel_id: '',
        channel_name: '',
        card_bin_group_id: '',
        type_id: '',
        warehouse: '',
        make_count: '',
        purpose: '',
        purpose_des: '',
        customer_id: '',
        customer_name: '',
        material_type: '',
        material_type_des: '',
        id: '',
        print_id: '',
        note: '',
        branch_office_data: [{
          branch_office_id: '',
          make_count: ''
        }]
      };
      this.addCardTypeList = [];
      this.addCardDisabledFlag = false;
      this.materialDisabled = false;
      this.isViewMode = false;
    },
    addCardCloseDialog: function addCardCloseDialog() {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.addCardDialogVisible = false;
        if (_this4.$refs.addCardForm) {
          _this4.$refs.addCardForm.clearValidate();
        }
      });
      this.addCardResetForm();
    },
    addCardConfirm: function addCardConfirm() {
      var _this5 = this;
      // 关联已有制卡：只能勾选一条
      if (this.cardMakeType === 2) {
        this.postCardMakeList();
        return;
      }
      if (this.cardMakeType === 1) {
        this.$refs.addCardForm.validate(function (valid) {
          if (valid) {
            _this5.addCardBtnLoading = true;
            // 物料印刷模式走物料申请的创建制卡接口，传汇总ID；项目交付模式传印刷单明细ID
            var params;
            if (_this5.mode === 'material') {
              params = _objectSpread(_objectSpread({}, _this5.addCardAddForm), {}, {
                summary_id: _this5.summary_id
              });
              // 未填写分配明细时不传，后端从汇总明细自动构建
              if (!params.branch_office_data || params.branch_office_data.length === 0) {
                delete params.branch_office_data;
              }
            } else {
              params = _objectSpread(_objectSpread({}, _this5.addCardAddForm), {}, {
                item_id: _this5.item_id || ''
              });
            }
            var request = _this5.mode === 'material' ? createMaterialCardMake(params) : addProjectDeliveryCardMake(params);
            request.then(function () {
              _this5.addCardBtnLoading = false;
              _this5.addCardDialogVisible = false;
              _this5.$message.success('制卡成功');
              _this5.$emit('success');
            }).finally(function () {
              _this5.addCardBtnLoading = false;
            });
          } else {
            _this5.addCardBtnLoading = false;
          }
        });
      }
    },
    postCardMakeList: function postCardMakeList() {
      var _this6 = this;
      if (this.cardMakeSelection.length === 0) {
        this.$message.warning('请选择一条制卡批次数据');
        return false;
      }
      if (this.cardMakeSelection.length > 1) {
        this.$message.warning('只能勾选一条数据');
        return false;
      }
      var selectRow = this.cardMakeSelection[0];
      this.addCardBtnLoading = true;
      // 物料印刷模式传汇总ID，项目交付模式传印刷单ID
      var request = this.mode === 'material' ? bindMaterialCardMake({
        summary_id: this.summary_id,
        card_make_id: selectRow.id
      }) : bindProjectDeliveryCardMake({
        print_id: this.print_id,
        card_make_id: selectRow.id
      });
      request.then(function () {
        _this6.$message.success('操作成功');
        _this6.addCardDialogVisible = false;
        _this6.$emit('success');
      }).finally(function () {
        _this6.addCardBtnLoading = false;
      });
    },
    addCardGetBranchCompany: function addCardGetBranchCompany() {
      var _this7 = this;
      getBranchCompanyList().then(function (res) {
        _this7.addCardBranchCompanyList = res.data.list;
      });
    },
    addCardAddDistributionItem: function addCardAddDistributionItem() {
      if (!this.addCardAddForm.branch_office_data) {
        this.addCardAddForm.branch_office_data = [];
      }
      this.addCardAddForm.branch_office_data.push({
        branch_office_id: '',
        make_count: ''
      });
    },
    addCardRemoveDistributionItem: function addCardRemoveDistributionItem(index) {
      this.addCardAddForm.branch_office_data.splice(index, 1);
    },
    addCardRemoteMethod: function addCardRemoteMethod(val) {
      this.$store.dispatch('user/getCompanyList', {
        val: val
      });
    },
    // 未售数量：优先取接口字段，物料印刷模式接口未返回时按 制卡数量-已制卡 计算
    getUnsoldNum: function getUnsoldNum(row) {
      if (row.unsold_num !== undefined && row.unsold_num !== null) {
        return row.unsold_num;
      }
      return (row.make_count || 0) - (row.make_yes || 0);
    },
    addCardGetCardMakeList: function addCardGetCardMakeList() {
      var _this8 = this;
      this.cardMakeListLoading = true;
      var isMaterial = this.mode === 'material';
      // 物料印刷模式按业务类型查询可绑定制卡列表；项目交付模式按印刷单ID查询
      var params = isMaterial ? _objectSpread(_objectSpread({}, this.cardMakeSearchPage), {}, {
        card_bin_group_id: this.addCardAddForm.card_bin_group_id
      }) : _objectSpread(_objectSpread({}, this.cardMakeSearchPage), {}, {
        print_id: this.print_id
      });
      var request = isMaterial ? getMaterialCardMakeList(params) : getProjectDeliveryCardMakeList(params);
      request.then(function (res) {
        _this8.cardMakeList = res.data.list;
        _this8.cardMakePage = res.pages;
      }).finally(function () {
        _this8.cardMakeListLoading = false;
      });
    },
    // 表格行选中：保证只选中一条
    addCardRowSelect: function addCardRowSelect(selection, row) {
      var _this9 = this;
      if (selection.length > 1) {
        // 只保留当前点击的这一行
        this.$nextTick(function () {
          _this9.$refs.cardMakeTable.clearSelection();
          _this9.$refs.cardMakeTable.toggleRowSelection(row, true);
          _this9.cardMakeSelection = [row];
        });
      } else {
        this.cardMakeSelection = selection;
      }
    },
    // 禁止表头全选
    addCardSelectAll: function addCardSelectAll(selection) {
      var _this0 = this;
      if (selection.length > 0) {
        this.$nextTick(function () {
          _this0.$refs.cardMakeTable.clearSelection();
        });
      }
    },
    addCardCurrentChange: function addCardCurrentChange(page) {
      this.cardMakeSearchPage.page = page;
      this.addCardGetCardMakeList();
    },
    addCardSizeChange: function addCardSizeChange(size) {
      this.cardMakeSearchPage.pagesize = size;
      this.cardMakeSearchPage.page = 1;
      this.addCardGetCardMakeList();
    }
  }
};